import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";

import { AdminProfile } from "@/portals/(admin)/(profile)/AdminProfile";
import { adminRoute, baseRoute } from "@/config/roles";
import type { CustomSection } from "@/components/Navigation/Toolbar/Views/DesktopToolbar";
import { FileList } from "@/portals/(shared)/(file-list)/FileList";
import { Footer } from "@/component-library/Footer";
import { getAdminProfile } from "@/redux/actions/auth";
import { Main2 } from "@/components/layout/Main";
import { MemberProfile } from "@/features/member-profile/MemberProfile";
import { NoteViewV2 } from "@/features/notes/(v2)/NoteViewV2";
import OmnisearchList from "@/portals/(admin)/(omnisearch)/OmnisearchList";
import PatientsList from "@/portals/(shared)/(patient-list)/PatientsList";
import { PrintNoteView } from "@/features/notes/(v2)/PrintNoteView";
import ReferralView from "@/containers/Dashboard/Providers/ReferralView";
import Settings from "@/portals/(shared)/components/SettingsPage";
import { Toolbar } from "@/components/Navigation/Toolbar/Toolbar";

import { CUSTOMER_SUCCESS_MANAGER } from "./constants/router";

export function AdminCSMRouter() {
  const dispatch = useDispatch();

  const navbarConfiguration = {
    customRenderSection: [] as CustomSection[],
    routeSection: { options: CUSTOMER_SUCCESS_MANAGER },
    selfSection: {},
  };

  React.useEffect(() => {
    dispatch(getAdminProfile());
  }, [dispatch]);

  return (
    <>
      <Toolbar
        baseRoute={baseRoute}
        isMessagingEnabled={false}
        navbarConfiguration={navbarConfiguration}
      />

      <Main2>
        <Switch>
          <Route component={AdminProfile} path={adminRoute + "/profile"} />
          <Route
            path={adminRoute + "/settings"}
            render={() => <Settings baseRoute={adminRoute} />}
          />
          <Route
            path={adminRoute + "/search"}
            render={(props) => <OmnisearchList {...props} baseRoute={adminRoute} />}
          />
          <Route component={PrintNoteView} path={adminRoute + "/patient/:patientId/export_notes"} />
          <Route component={NoteViewV2} path={adminRoute + "/patient/:patientId/note/:noteId/v2"} />
          <Route component={MemberProfile} path={adminRoute + "/patient/:patientId/profile/v2"} />
          <Route
            path={adminRoute + "/patient/:patientId/file"}
            render={() => <FileList type="patient" />}
          />
          <Route
            path={adminRoute + "/referral/:referralCode/file"}
            render={() => <FileList type="referral" />}
          />
          <Route component={ReferralView} path={adminRoute + "/referral/:referralCode"} />
          <Route path={adminRoute + "/patient"} render={(props) => <PatientsList {...props} />} />
          <Redirect from={adminRoute} to={adminRoute + "/patient"} />
        </Switch>
      </Main2>

      <Footer />
    </>
  );
}
